import {FC} from 'react';
import {ToastTransition, Zoom} from 'react-toastify';
import {CloseWrapper, StyledToastContainer} from './CustomToastContainer.styles';
import {Close} from '@carbon/icons-react';
import {theme} from '@styles/theme';

interface CustomToastContainerProps {
  position?:
    | 'top-right'
    | 'top-center'
    | 'top-left'
    | 'bottom-right'
    | 'bottom-center'
    | 'bottom-left';
  hideProgressBar?: boolean;
  containerId?: string;
  autoClose?: number | false;
  transition?: ToastTransition | undefined;
}

interface CloseButtonProps {
  closeToast?: () => void;
}

// Компонент кнопки закрытия
const CloseButton: FC<CloseButtonProps> = ({closeToast}) => {
  return (
    <CloseWrapper onClick={closeToast}>
      <Close size={12} fill={theme.colors.basic03} />
    </CloseWrapper>
  );
};

const CustomToastContainer: FC<CustomToastContainerProps> = ({
  position,
  hideProgressBar = true,
  containerId,
  autoClose = false,
  transition = Zoom,
}) => {
  return (
    <StyledToastContainer
      position={position}
      hideProgressBar={hideProgressBar}
      containerId={containerId}
      icon={false}
      autoClose={autoClose}
      closeButton={CloseButton}
      transition={transition}
      newestOnTop
    />
  );
};

export default CustomToastContainer;
